import React, { useEffect } from 'react';
import { loadLanguagePack } from '@americanexpress/one-app-ducks';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import DataManager from '@americanexpress/data-manager';
import { AmexDDLRegister, getAmexDataManagerConfig } from 'axp-data-manager-utils';
import { IntlProvider } from 'react-intl';
import { locationShape } from '@americanexpress/one-app-router';
import childRoutes from '../childRoutes';

const MODULE_NAME = 'axp-servicing-internet-root';

export const AxpServicingInternetRoot = ({
  locale = 'en-US',
  languageData,
  children,
  location: { pathname },
}) => {
  useEffect(() => {
    if (global.BROWSER) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return (
    <div>
      <Helmet>
        <link
          rel="stylesheet"
          href="https://www.aexp-static.com/cdaas/one/statics/axp-dls/6.13.2/package/dist/6.13.2/styles/dls.min.css"
        />
        <link rel="icon" href="https://www.americanexpress.com/favicon.ico" />
        <meta charSet="utf-8" />
        <title>American Express - Issuance</title>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <body className="dls-gray-02-bg" />
      </Helmet>
      {/* eslint-disable-next-line react/jsx-props-no-spreading -- - */}
      <DataManager {...getAmexDataManagerConfig()}>
        <AmexDDLRegister />
        <IntlProvider locale={locale} messages={languageData}>
          <div className="flex dls-white-bg pad-1 margin-2-l margin-2-r display-block">
            <span className="dls-logo-bluebox-solid-md">
              <img
                src="https://www.aexp-static.com/cdaas/one/statics/axp-static-assets/2.16.0/package/dist/img/logos/dls-logo-bluebox-solid.svg"
                alt="American Express"
              />
            </span>
          </div>
          {children}
        </IntlProvider>
      </DataManager>
    </div>
  );
};

export const TestableAxpServicingInternetRoot = AxpServicingInternetRoot;

AxpServicingInternetRoot.propTypes = {
  languageData: PropTypes.shape({}),
  locale: PropTypes.string,
  children: PropTypes.node.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

AxpServicingInternetRoot.childRoutes = childRoutes;

/* istanbul ignore next */
if (!global.BROWSER) {
  // eslint-disable-next-line global-require -- require needs to be inside browser check
  AxpServicingInternetRoot.appConfig = require('../config').default;
}

export const loadModuleData = async ({ store: { dispatch } }) => {
  await dispatch(loadLanguagePack(MODULE_NAME, { fallbackLocale: 'en-US' }));
};

AxpServicingInternetRoot.holocron = {
  name: MODULE_NAME,
  loadModuleData,
};

export default oneAppModuleWrapper(MODULE_NAME)(AxpServicingInternetRoot);
